<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="page-title flex u-w-100">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Components</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
</div>